import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Flame, Skull, Laugh, Lock } from "lucide-react";
import { isLocked, lock } from "../lib/locks";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BTN_STYLES = {
  fire: { bg: "#FF003C", fg: "#fff", Icon: Flame, label: "FIRE" },
  skull: { bg: "#ffffff", fg: "#000", Icon: Skull, label: "SKULL" },
  laugh: { bg: "#FFEA00", fg: "#000", Icon: Laugh, label: "LMAO" },
};

export const ReactionButtons = ({ incidentId, reactions, onUpdate }) => {
  const [busy, setBusy] = useState(null);
  const [bump, setBump] = useState(null);
  const [locked, setLocked] = useState(() =>
    Object.fromEntries(Object.keys(BTN_STYLES).map((t) => [t, isLocked(`react:${incidentId}:${t}`)]))
  );

  const handle = async (type) => {
    if (busy) return;
    if (locked[type]) {
      toast.error("ONE VOTE PER WITNESS. NICE TRY.");
      return;
    }
    setBusy(type);
    setBump(type);
    try {
      const res = await axios.post(`${API}/incidents/${incidentId}/react`, { type });
      onUpdate && onUpdate(res.data.reactions);
      lock(`react:${incidentId}:${type}`);
      setLocked((l) => ({ ...l, [type]: true }));
    } catch (e) {
      console.error("react error", e);
    } finally {
      setBusy(null);
      setTimeout(() => setBump(null), 220);
    }
  };

  return (
    <div className="flex flex-wrap items-stretch gap-3" data-testid={`reactions-${incidentId}`}>
      {Object.entries(BTN_STYLES).map(([type, cfg]) => {
        const { bg, fg, Icon, label } = cfg;
        const count = reactions?.[type] ?? 0;
        const isBump = bump === type;
        const isLockedBtn = locked[type];
        return (
          <button
            key={type}
            onClick={() => handle(type)}
            data-testid={`reaction-${type}-${incidentId}`}
            data-locked={isLockedBtn ? "true" : "false"}
            title={isLockedBtn ? "You already voted on this one" : undefined}
            className={`brutal-press group inline-flex items-center gap-2 px-3 py-2 brutal-border font-mono text-xs uppercase font-bold ${
              isBump ? "translate-x-1 translate-y-1" : ""
            } ${isLockedBtn ? "opacity-70" : ""}`}
            style={{
              background: bg,
              color: fg,
              boxShadow: isBump ? "none" : "4px 4px 0 0 #000",
            }}
          >
            {isLockedBtn ? <Lock size={16} strokeWidth={3} /> : <Icon size={16} strokeWidth={3} />}
            <span>{label}</span>
            <span
              className="font-mono px-1.5 py-0.5 text-[11px]"
              style={{ background: "#000", color: bg }}
            >
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
};
